import moment from 'moment';
import { isNil } from 'ramda';
import i18n from 'services/i18n';

export default values => {
  const errors = {};

  if (values.shocksDate && values.shocksDate.filter(shock => !isNil(shock)).length) {
    const patientPhoneArrayErrors = [];

    values.shocksDate.forEach((shock, index) => {
      const patientPhoneErrors = {};
      if (shock && shock.shockDate && !moment(shock.shockDate, 'MM/DD/YYYY', true).isValid()) {
        patientPhoneErrors.shockDate = i18n.t('validation:dateFormat');
        patientPhoneArrayErrors[index] = patientPhoneErrors;
      }

      if (shock && shock.shockHour && !moment(shock.shockHour, 'HH:mm', true).isValid()) {
        patientPhoneErrors.shockHour = i18n.t('validation:timeFormat');
        patientPhoneArrayErrors[index] = patientPhoneErrors;
      }
    });

    if (patientPhoneArrayErrors.length) {
      errors.shocksDate = patientPhoneArrayErrors;
    }
  }
  if (values.pacing && !/^\+?(0|[1-9]\d*)$/.test(values.pacing)) {
    errors.pacing = i18n.t('validation:integerPositive');
  }
  if (values.shock && !/^\+?(0|[1-9]\d*)$/.test(values.shock) && !values.shockNa) {
    errors.shock = i18n.t('validation:integerPositive');
  }

  if (!values.shockNa && !values.shock) {
    errors.shock = i18n.t('validation:fieldRequired');
  }

  return errors;
};
